import React from 'react';
import
DigitalOnboardingAccountInfoTemplate
  from 'Views/Page/Content/Templates/DigitalOnboardingAccountInfo/DigitalOnboardingAccountInfoTemplate';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import BalanceSheetAccountTypeStepTemplate
  from 'Views/Page/Content/Modal/Layouts/BalanceSheetAccountTypeStep/Layout/BalanceSheetAccountTypeStepTemplate';

export const BalanceSheetAccountTypeDOLayout = () => {
  const { refreshOnboardingStepCollection } = useSurveyContext();

  return (
    <BalanceSheetAccountTypeStepTemplate onRefresh={refreshOnboardingStepCollection} infoLayoutComponent={DigitalOnboardingAccountInfoTemplate} useFD={false} />
  );
};
